if (!customElements.get('marquee-bar')) {
  customElements.define(
    'marquee-bar',
    class MarqueeBar extends HTMLElement {
      constructor() {
        super();

        this.messageContainerEl = this.querySelector('.announcement-bar__message');
        this.messageEl = this.messageContainerEl.querySelector('li');
        this.viewportWidth = document.documentElement.clientWidth;

      }

      connectedCallback() {
        window.addEventListener('resize', debounce((event) => {
          if(document.documentElement.clientWidth === this.viewportWidth) return;
          this.onResize();
        }, ON_CHANGE_DEBOUNCE_TIMER));

        this.onResize();
      }

      pause() {
        setTimeout(() => {
          this.classList.remove('playing');
        });
      }

      play() {
        setTimeout(() => {
          this.classList.add('playing');
        }, 100);
      }

      onResize = (force = false) => {
        if(this.querySelector('[data-autoplay]').dataset.autoplay === 'false') return;
        this.viewportWidth = document.documentElement.clientWidth;
        this.pause();
        this.deleteClones();
        this.addClones();
        this.play();
      };

      addClones() {
        const cloneCount = (Math.ceil(document.documentElement.clientWidth / this.messageEl.clientWidth) - 1) * 1;
        if(cloneCount > 0) {
          for(var i = 0; i < cloneCount; i++) {
            const messageElClone = this.messageEl.cloneNode(true);
            messageElClone.classList.add('clone');
            this.messageContainerEl.appendChild(messageElClone);
          }
        }
        const containerClone = this.messageContainerEl.cloneNode(true);
        containerClone.setAttribute('aria-hidden', true);
        containerClone.classList.add('clone');
        this.messageContainerEl.parentNode.appendChild(containerClone);
        this.classList.add('cloned');
      }
      
      deleteClones() {
        this.classList.remove('cloned');
        this.querySelectorAll('.clone').forEach((clonedEl) => clonedEl.remove());
      }

    }
  );
}
